import type { Theme } from '@mui/material';
import { alpha } from '@mui/material'

export const tableCustomStyle = {
  border: 'none',
  overflowY: 'hidden',
  overflowX: 'auto',
  '& .MuiDataGrid-main': {
    overflowY: 'hidden',
    overflowX: 'auto',
  },
  '& .MuiDataGrid-virtualScroller': {
    overflowY: 'hidden !important',
    overflowX: 'auto !important',
  },
  '& .MuiDataGrid-virtualScrollerContent': {
    overflowY: 'hidden',
    overflowX: 'visible',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    overflowY: 'hidden',
    overflowX: 'visible',
  },
  '& .MuiDataGrid-viewport': {
    overflowY: 'hidden',
    overflowX: 'auto',
  },
  '& .MuiDataGrid-cell': {
    borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.divider, 0.05)}`,
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
    borderBottom: (theme: Theme) => `2px solid ${theme.palette.divider}`,
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 600,
    },
  },
  '& .MuiDataGrid-row': {
    '&:hover': {
      backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.02),
      cursor: 'pointer',
    },
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
}
